export default function initAccordion() {
    const accordions = document.querySelectorAll('.accordionBtn');
    if (!accordions.length) return; // Exit early if no accordions exist

    $(accordions).on('click', function () {
        const $this = $(this);
        const $content = $this.closest('.accordion__row').find('.accordion__row__content');

        // Close all others (optional)
        $('.accordion__row__content').not($content).slideUp();
        $('.accordionBtn').not($this).removeClass('active').attr('aria-expanded', 'false');

        // Toggle this one
        $content.stop(true, true).slideToggle();
        $this.toggleClass('active');

        // Accessibility
        const isExpanded = $this.hasClass('active');
        $this.attr('aria-expanded', isExpanded);
    });
}